import { createComponentStore } from './createComponentStore';
export const useGeneralInfoComponentStore = createComponentStore('generalInfoComponent');
